module.exports = __webpack_public_path__ + "static/media/Home_ECE.41bf6af8.jpg";